let keysToSkip = [
    'form',
'data-markers',
'url_bet_home',
'data-links',
'time_event',
'date_event',
];

export default function GeneratorLinkSurebet(dataSurebet, profit) {
    let data_markers = dataSurebet['data-markers'];
    let dataLinks = dataSurebet['data-links'];
    let keysDataSurebet = Object.keys(dataSurebet);
    let dataExtension = {};
    dataExtension['profit'] = profit;

    for(let i = 0; i < keysDataSurebet.length; i++){
        let keySurebetExtension = keysDataSurebet[i];
        if ( keysDataSurebet[i] === ('url_bet')){
            continue
        }
        if ( keysToSkip.indexOf(keySurebetExtension) === -1){
            dataExtension[keySurebetExtension] = dataSurebet[keySurebetExtension];
        }

    }

    let dataExtensionJson = JSON.stringify(dataExtension);
    let encodedDataArb = encodeURIComponent(dataExtensionJson);
    
    let strUrl = `${dataSurebet["url_bet"]}?data-arb=${encodedDataArb}&data-links=${dataLinks}&data-markers=${data_markers}`;

    return strUrl;
}


export function GeneratorLinkSurebet_000(dataSurebet, profit) {
    let keysDataSurebet = Object.keys(dataSurebet);
    let dataExtension = {};
    dataExtension['profit'] = profit;

    for(let i = 0; i < keysDataSurebet.length; i++){
        let keySurebetExtension = keysDataSurebet[i];
        if ( keysDataSurebet[i] === ('url_bet')){
            continue
        }
        else if ( keysToSkip.indexOf(keySurebetExtension) === -1){
            dataExtension[keySurebetExtension] = dataSurebet[keySurebetExtension];
        }

    }
    

    let dataExtensionJson = JSON.stringify(dataExtension);
    let encodedDataArb = encodeURIComponent(dataExtensionJson);
    
    let strUrl = `${dataSurebet["url_bet"]}&data-arb=${encodedDataArb}`;
    
    return strUrl;
}